import { Component, Input, OnInit } from '@angular/core';
import { SeriesMeta } from '../../models/view/series-meta';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'series',
    templateUrl: './series.component.html',
    styleUrls: ['./series.component.scss'],
    imports: [DatePipe],
    standalone: true,
})
export class SeriesComponent implements OnInit {
    @Input() series: SeriesMeta;

    constructor() {
        // empty
    }

    ngOnInit() {
        // empty
    }
}
